<nav class="navbar navbar-expand-lg stroke ">
  <div class="container-fluid">
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse  navbar-collapse ms-lg-auto  " id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">

        <li class="nav-item">
          <a class="nav-link" routerLinkActive="activeRoute" routerLink="/nosotros">Nosotros</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="activeRoute"  routerLink="/servicios"><span>Servicios</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="activeRoute" routerLink="/especialidades">Especialidades</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="activeRoute" style="color: var(--bs-red);"  routerLink="/ambulancia"><span>Ambulancia</span></a>
        </li>

        <li class="nav-item align-content-lg-end">
          <a class="nav-link" routerLinkActive="activeRoute" routerLink="/responsabilidad-social">Responsabilidad Social</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="activeRoute" routerLink="/contactanos">Contáctanos</a>
        </li>




      </ul>

      <ol class="navbar-nav me-end mb-2 mb-lg-0 itemPromotion" style="width: fit-content">

        <li class="nav-item">
          <a class="nav-link"   routerLink="/promociones">
            <span>Promociones</span></a>
        </li>
      </ol>
        <a href="https://serviciosenlinea.medilink.com.ec" target="_blank" class="btn-getstarted ">Servicios en Línea <i class="bi bi-arrow-up-right-circle-fill"></i></a>




    </div>
  </div>
</nav>



